import { Injectable } from '@angular/core';
import { Color } from '@lsq-frontend/common-ui';
import { I18n } from '@ngx-translate/i18n-polyfill';

export interface IInvoiceState {
    statusText: string;
    color?: Color;
}

export class InvoicesStates {
    public static Eligible: IInvoiceState = {
        statusText: 'Eligible',
        color: Color.Green
    };

    public static Pending: IInvoiceState = {
        statusText: 'Pending',
        color: Color.Yellow
    };

    public static Paid: IInvoiceState = {
        statusText: 'Early Paid'
    };

    public static Ineligible: IInvoiceState = {
        statusText: 'Ineligible'
    };
}

export enum InvoicesStatus {
    Eligible = 1,
    Pending = 2,
    Paid = 3,
    Ineligible = 4
}

// TODO(story/13756): Remove once the need for an arbitrary take amount is gone.
export const TAKE_ALL = 10000;

@Injectable({ providedIn: 'root' })
export class SupplyChainCopy {
    public INVOICE_AMOUNT_TOOLTIP = this._i18n(
        'The total amount approved by the customer from the original invoice.'
    );
    public DISCOUNT_AMOUNT_TOOLTIP = this._i18n(
        'Fee that is applied to the approved invoice amount, determined by the Fee Rate. Amount * Fee Rate = Fee.'
    );
    public AVAILABLE_AMOUNT_TOOLTIP = this._i18n(
        'The final amount, with fees applied, that is available for early payment. Amount - Fee = Available.'
    );
    public PAID_AMOUNT_TOOLTIP = this._i18n(
        'The final amount, with fees applied, that was paid early. Amount - Fee = Paid.'
    );
    public DUE_IN_TOOLTIP = this._i18n('The number of days from the due date on the invoice.');
    public FEE_RATE_TOOLTIP = this._i18n(
        'The rate at which your invoice fee is determined based on how early you request payment, charged at the daily rate. Days Until Due * Daily Rate = Fee Rate.'
    );

    constructor(private _i18n: I18n) {}
}

export const ROUTING_NUMBER_INFO_URL = `https://www.routingnumbers.info/api/data.json?rn=`;
